import React from 'react';
import moment from 'moment';

type ActivityDeadlineProps = {
  deadline: string | Date;
};

function ActivityDeadline({
  deadline,
}: ActivityDeadlineProps) {
  const deadlineMoment = moment(deadline);
  const deadlineDay = deadlineMoment.format('dddd');
  const deadlineTime = deadlineMoment.format('lll');

  return (
    deadline && (
      <div className='date'>
        <span className='day'>{deadlineDay}</span>
        <span className='time'>{deadlineTime}</span>
      </div>
    )
  );
}

export default ActivityDeadline;
